import React, { useState } from "react";
import { IconDownload, IconEye } from "@tabler/icons-react";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import ListView from "../../components/common/ListView";
import ViewModal from "./_components/ViewModal";

const invoiceData = [
  {
    id: 1,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: false,
  },
  {
    id: 2,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Paid",
    download: "Downloading...",
    active: true,
  },
  {
    id: 3,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: false,
  },
  {
    id: 4,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Paid",
    active: true,
  },
  {
    id: 5,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: true,
  },
];

const InvoiceManagement: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <div className="p-4 space-y-4">
        {/* <h1 className="text-3xl text-[#212121] ">Invoice Management</h1> */}
        <div>
          <div className="flex items-center">
            <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
              <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
                Invoice Lists
              </h1>
              <div className="flex items-center gap-2">
                <ColumnsFilter columnsData={[]} />
                <DropdownFilter filterheadings={[]} />
                <NormalSearch />
              </div>
            </div>
            <div className="relative ml-5">
              <div className=" flex items-center gap-2 justify-end rounded-full">
                <button
                  // onClick={handleDownloadXLSX}
                  className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                >
                  <IconDownload stroke={1.5} size={24} />
                </button>
              </div>
            </div>
          </div>

          <div className=" bg-[#F7F6F2] rounded-r-3xl rounded-b-3xl">
            {" "}
            <ListView
              data={invoiceData}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "S/N", render: (_, i) => i + 1 },
                {
                  label: "Invoice Id",
                  render: (c) => c.invoiceId,
                },
                { label: "Date", render: (c) => c.date },
                { label: "Description", render: (c) => c.description },
                {
                  label: "Amount",
                  render: (c) => c.amount,
                },
                {
                  label: "Due Date",
                  render: (c) => c.dueDate,
                },
                {
                  label: "Status",
                  render: (c) => {
                    const isAssigned = c.status === "Paid";
                    const statusClasses = isAssigned
                      ? "bg-[#20BF55]/20 border border-[#20BF55] text-[#20BF55]"
                      : "bg-[#FF4848]/20 border border-[#FF4848] text-[#FF4848]";
                    return (
                      <div className="flex justify-center">
                        <button
                          className={`rounded-full w-24 px-4 py-1  text-center ${statusClasses}`}
                        >
                          {c.status}
                        </button>
                      </div>
                    );
                  },
                },
                {
                  label: "Actions",
                  render: (c: any) => (
                    <div className="space-x-2 flex items-center justify-center">
                      <button
                        onClick={openModal}
                        className="p-2 border rounded-full bg-[#F7F6F2]"
                      >
                        <IconEye />
                      </button>
                      <button
                        onClick={openModal}
                        className="px-4 text-center py-2 border rounded-full bg-[#F7F6F2]"
                      >
                        Download
                      </button>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>

      <ViewModal open={isOpen} onClose={closeModal} />
    </>
  );
};

export default InvoiceManagement;
